import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { format, subDays, addDays } from 'date-fns';
import { upperFirst } from 'lodash';

const ACTIONS = {
  last: subDays,
  next: addDays,
};

const TableFilterDateRange = ({ onChange, action }) => {
  const dateRangeOptions = [{
    label: `${upperFirst(action)} 30 Days`,
    value: 30,
  }, {
    label: `${upperFirst(action)} 60 Days`,
    value: 60,
  }, {
    label: `${upperFirst(action)} 90 Days`,
    value: 90,
  }, {
    label: `${upperFirst(action)} 120 Days`,
    value: 120,
  }, {
    label: 'All Days',
    value: 0,
  }];

  const [value, setValue] = useState();

  const setFilterValue = useMemo(() => (e) => {
    setValue(e);

    if (e.value > 0) {
      onChange(format(ACTIONS[action](new Date(), e.value), 'MM/DD/YYYY'));
    } else {
      onChange(undefined);
    }
  }, [action]);

  return (
    <Select
      value={value}
      onChange={setFilterValue}
      options={dateRangeOptions}
      menuPortalTarget={document.body}
      className="w-100 form-select pt-0 pb-2 px-0"
      classNamePrefix="react-select"
    />
  );
};

TableFilterDateRange.propTypes = {
  onChange: PropTypes.func.isRequired,
  action: PropTypes.string,
};

TableFilterDateRange.defaultProps = {
  action: 'last',
};

export default TableFilterDateRange;
